import type { FC } from 'react';

import { FormattedMessage } from '../FormattedMessage';
import { MainButton } from '../MainButton';
import { SharingWrapper } from '../SharingWrapper';
import { Root } from './styles';
import type { FooterProps } from './types';

export const Footer: FC<FooterProps> = ({ isBasketSharingEnabled, isSharingButtonActive }) => (
  <Root>
    <MainButton>
      <FormattedMessage id="goToBasket" />
    </MainButton>
    {isBasketSharingEnabled ? <SharingWrapper isSharingButtonActive={isSharingButtonActive} /> : null}
  </Root>
);
